import React, { useState } from 'react';
import { Button, Typography, InputBase, Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PasswordGuidelines from '~/_base/components/passwordGuidelines';

export default function EnterNewPassword() {
  const classes = useStyles();
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  function handleRequestPasswordClick() {
    document.getElementsByTagName('form')[0].submit();
  }

  function handleKeyPress(
    e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    e.preventDefault();
    if (e.key === 'Enter') {
      handleRequestPasswordClick();
    }
  }

  function shouldRender() {
    const elements = document.querySelectorAll(
      "[data-mount='ape_password_reset_enter_details']"
    );
    return elements.length > 0;
  }

  if (!shouldRender()) {
    return <div />;
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={6}>
        <PasswordGuidelines />
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        <Typography variant="h1">Reset Password</Typography>
        <Typography variant="body1" className={classes.bodyText}>
          Please enter and confirm a new password below.
        </Typography>
        <div className={classes.inputContainer}>
          <InputBase
            onKeyUp={e => handleKeyPress(e)}
            id="user_password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            name="user[password]"
            type="password"
            fullWidth
            placeholder="New password"
          />
        </div>
        <div className={classes.inputContainer}>
          <InputBase
            onKeyUp={e => handleKeyPress(e)}
            id="user_password_confirmation"
            value={passwordConfirm}
            onChange={e => setPasswordConfirm(e.target.value)}
            name="user[password_confirmation]"
            type="password"
            fullWidth
            placeholder="Password confirmation"
          />
        </div>
        <Button
          variant="contained"
          color="primary"
          className={classes.resetPasswordButton}
          type="button"
          onClick={() => handleRequestPasswordClick()}
        >
          Reset Password
        </Button>
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles(theme => ({
  bodyText: {
    margin: theme.spacing(3, 0),
  },
  inputContainer: {
    marginBottom: theme.spacing(1),
  },
  resetPasswordButton: {
    marginTop: theme.spacing(5),
    width: '100%',
  },
  container: {
    maxWidth: 328,
    margin: '0 auto',
  },
}));
